import { Vector2 } from "api/types/sketch";
import { BumpArcConstruct } from "api/types/sketch";
import { constructFullArc } from "../construct";
import { AnyAction } from "@reduxjs/toolkit";
import { getControlPoint } from "functions/sketch/math";

export function drawPrintCutFullWidth(
  painter: AnyAction,
  start: Vector2,
  end: Vector2,
  depth: number,
  angle: number,
  zoom: number
) {
  const bump_construct: BumpArcConstruct = constructFullArc(start, end, angle, depth, zoom);
  painter.lineTo(bump_construct.start.X, bump_construct.start.Y);
  const p1: Vector2 = getControlPoint(bump_construct.start, bump_construct.end, 0.5, bump_construct.top);
  painter.quadraticCurveTo(p1.X, p1.Y, bump_construct.end.X, bump_construct.end.Y);
}
